import { getPatternStyles, patternFns } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const commonScrollbarConfig = {
transform(props) {
  const { horizontalScroll, ...rest } = props;
  return {
    "&::-webkit-scrollbar": {
      width: 8,
      height: horizontalScroll ? 8 : "auto"
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: 20,
      backgroundClip: "padding-box",
      border: "2px solid transparent",
      backgroundColor: "mui.primary.stroke"
    },
    ...rest
  };
},
defaultValues:{horizontalScroll:false}}

export const getCommonScrollbarStyle = (styles = {}) => {
  const _styles = getPatternStyles(commonScrollbarConfig, styles)
  return commonScrollbarConfig.transform(_styles, patternFns)
}

export const commonScrollbar = (styles) => css(getCommonScrollbarStyle(styles))
commonScrollbar.raw = getCommonScrollbarStyle